export default __webpack_public_path__ + "static/media/sdcsdcs2.204a48bb.png";